__webpack_require__.p = "/typing_game/";